<odx-tab-bar (selectedTabChanged)="selectedTabIndex.set($event.selectedIndex)">
  <odx-tab-bar-item i18n="@@floorplan.details.transmitter.tabBar.tab1">Allgemeine Informationen</odx-tab-bar-item>
  <odx-tab-bar-item i18n="@@floorplan.details.transmitter.tabBar.tab2">Produkte</odx-tab-bar-item>
</odx-tab-bar>

@if (selectedTabIndex() === 0) {
  <div odxLayout="flex" class="flex-column">
    <h5 i18n="@@floorplan.details.transmitter.title" class="odx-title-5">Allgemeine Informationen</h5>
    <div odxLayout="flex gap-none" class="flex-column">
      <app-floorplan-transmitter-radius-form [transmitter]="transmitter()"></app-floorplan-transmitter-radius-form>
      @if (isTransmitter()) {
        <div odxLayout="flex">
          <odx-checkbox
            odxLayout="2@desktop 3@tablet 4@phone"
            [checked]="detectionRangeControl.value"
            (click)="$event.preventDefault(); $event.stopPropagation(); onDetectionRangeToggle(!detectionRangeControl.value)"
          >
          </odx-checkbox>
          <span
            odxLayout="10@desktop 9@tablet 8@phone"
            class="odx-text"
            i18n="@@floorplan.details.transmitter.detectionRange.toggle"
          >
            Standardwert für Radius Überwachungsbereich aus Konfiguration verwenden
          </span>
        </div>
      }
      <form [formGroup]="editTransmitterForm" odxForm [readonly]="transmitter().locked">
        <odx-form-field i18n-label="@@editTransmitterForm.label.bmk" label="BMK">
          <input
            type="text"
            formControlName="bmk"
            odxFormFieldControl
            i18n-placeholder="@@editTransmitterForm.placeholder.bmk"
            placeholder="BMK"
          />
        </odx-form-field>
        <odx-form-field i18n-label="@@editTransmitterForm.label.sector" label="Bereich">
          <input
            type="text"
            formControlName="sector"
            odxFormFieldControl
            i18n-placeholder="@@editTransmitterForm.placeholder.sector"
            placeholder="Bereich"
          />
        </odx-form-field>
        <odx-form-field i18n-label="@@editTransmitterForm.label.installationHeight" label="Montagehöhe">
          <input
            type="text"
            formControlName="installationHeight"
            odxFormFieldControl
            i18n-placeholder="@@editTransmitterForm.placeholder.installationHeight"
            placeholder="Montagehöhe"
          />
        </odx-form-field>
        <p>
          <odx-checkbox formControlName="exProtection" i18n="@@editTransmitterForm.label.exProtection">Ex-Schutz </odx-checkbox>
        </p>
        <p>
          <odx-checkbox formControlName="hasRemoteSensor" i18n="@@editTransmitterForm.label.hasRemoteSensor">
            Remote Sensor
          </odx-checkbox>
        </p>
      </form>
    </div>
  </div>
}
@if (selectedTabIndex() === 1) {
  <app-floorplan-custom-part-numbers [floorplanItem]="transmitter()"></app-floorplan-custom-part-numbers>
}
